// extracted by mini-css-extract-plugin
export default {"login":"EditEmployees_login__FWEbY","mainDog":"EditEmployees_mainDog__DaAG5","createEmployees":"EditEmployees_createEmployees__aiMUA"};